'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  /* Fit the whole browser window */\n  width: 100vw;\n  height: 100vh;\n\n  /* Setup typography */\n  font-family: ', ';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  color: ', ';\n'], ['\n  /* Fit the whole browser window */\n  width: 100vw;\n  height: 100vh;\n\n  /* Setup typography */\n  font-family: ', ';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globalBackground = require('./global-background');

var _globalBackground2 = _interopRequireDefault(_globalBackground);

var _remoteControl = require('./remote-control');

var _remoteControl2 = _interopRequireDefault(_remoteControl);

var _fullscreenMode = require('./fullscreen-mode');

var _fullscreenMode2 = _interopRequireDefault(_fullscreenMode);

var _slideshowMode = require('./slideshow-mode');

var _slideshowMode2 = _interopRequireDefault(_slideshowMode);

var _birdsEyeMode = require('./birds-eye-mode');

var _birdsEyeMode2 = _interopRequireDefault(_birdsEyeMode);

var _theme = require('../theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// default theme for styled components


var modes = {
  FULLSCREEN: 'FULLSCREEN',
  SLIDESHOW: 'SLIDESHOW',
  BIRDSEYE: 'BIRDSEYE'

  // Gets the current slide index from
  // the url hash e.g. /#10
};var extractIndexFromLocation = function extractIndexFromLocation() {
  var numbers = window.location.hash.replace(/\D/g, '');
  return parseInt(numbers) || 0;
};

var Presentation = function (_Component) {
  _inherits(Presentation, _Component);

  function Presentation(props) {
    _classCallCheck(this, Presentation);

    var _this = _possibleConstructorReturn(this, (Presentation.__proto__ || Object.getPrototypeOf(Presentation)).call(this, props));

    _this.shiftSlide = function (shift) {
      var _this$state = _this.state,
          slides = _this$state.slides,
          currentSlide = _this$state.currentSlide;


      var id = currentSlide + shift;
      var limited = Math.max(0, Math.min(id, slides.length - 1));

      _this.switchSlide(limited);
    };

    _this.switchSlide = function (id) {
      window.location.hash = id.toString();
      _this.setState({ currentSlide: id });
    };

    _this.toggleFullscreen = function (goFullscreen) {
      var useFullscreenAPI = _this.props.useFullscreenAPI;


      if (typeof goFullscreen === 'undefined') {
        goFullscreen = !_this.state.presentMode === modes.FULLSCREEN;
      }

      if (goFullscreen && useFullscreenAPI) {
        var docEl = document.documentElement;

        // Use browser's Fullscreen API
        if (docEl && docEl.webkitRequestFullscreen) {
          docEl.webkitRequestFullscreen();
        }
      }

      _this.setState(function (state) {
        return {
          presentMode: goFullscreen ? modes.FULLSCREEN : modes.SLIDESHOW
        };
      });
    };

    _this.toggleBirdsEye = function () {
      _this.setState(function (state) {
        return {
          presentMode: state.presentMode === modes.BIRDSEYE ? modes.SLIDESHOW : modes.BIRDSEYE
        };
      });
    };

    _this.toggleToc = function (shown) {
      var visible = typeof shown === 'undefined' ? !_this.state.showToc : shown;

      _this.setState({
        showToc: visible
      });
    };

    var currentIndex = Math.min(props.slides.length, extractIndexFromLocation());

    _this.state = {
      slides: props.slides,
      presentationName: props.name,
      presentMode: modes.SLIDESHOW,
      currentSlide: currentIndex,
      showToc: props.tableOfContents,

      slideWidth: props.baseWidth,
      slideHeight: props.baseWidth / props.aspectRatio
    };
    return _this;
  }

  _createClass(Presentation, [{
    key: 'getConnectedState',
    value: function getConnectedState() {
      var _this2 = this;

      var _state = this.state,
          slides = _state.slides,
          currentSlide = _state.currentSlide,
          presentMode = _state.presentMode;


      return _extends({}, this.state, {

        slide: _extends({}, slides[currentSlide], {
          id: currentSlide,
          index: currentSlide,
          isFirst: currentSlide <= 0,
          isLast: currentSlide >= slides.length - 1
        }),

        isSlideshow: presentMode === modes.SLIDESHOW,
        isFullscreen: presentMode === modes.FULLSCREEN,
        isBirdsEye: presentMode === modes.BIRDSEYE,
        toggleFullscreen: this.toggleFullscreen,

        switchSlide: this.switchSlide,
        toggleToc: this.toggleToc,
        toggleBirdsEye: this.toggleBirdsEye,
        showNextSlide: function showNextSlide() {
          return _this2.shiftSlide(+1);
        },
        showPrevSlide: function showPrevSlide() {
          return _this2.shiftSlide(-1);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var state = this.getConnectedState();

      var theme = _extends({}, _theme2.default, this.props.theme);

      return _react2.default.createElement(
        _styledComponents.ThemeProvider,
        { theme: theme },
        _react2.default.createElement(
          GlobalContainer,
          null,
          _react2.default.createElement(_globalBackground2.default, state),
          _react2.default.createElement(_remoteControl2.default, {
            onNext: state.showNextSlide,
            onPrev: state.showPrevSlide,
            onMute: function onMute() {
              return null;
            }
          }),
          state.isFullscreen && _react2.default.createElement(_fullscreenMode2.default, state),
          state.isSlideshow && _react2.default.createElement(_slideshowMode2.default, state),
          state.isBirdsEye && _react2.default.createElement(_birdsEyeMode2.default, state)
        )
      );
    }
  }]);

  return Presentation;
}(_react.Component);

Presentation.propTypes = {
  name: _propTypes2.default.string,
  aspectRatio: _propTypes2.default.number,
  theme: _propTypes2.default.object,
  tableOfContents: _propTypes2.default.bool,
  useFullscreenAPI: _propTypes2.default.bool
};
Presentation.defaultProps = {
  name: 'An awesome presentation',
  aspectRatio: 16.0 / 9.0,
  baseWidth: 1066.0,
  tableOfContents: false,
  useFullscreenAPI: false,
  theme: {}
};


var GlobalContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.baseFont;
}, function (props) {
  return props.theme.textColor;
});

exports.default = Presentation;